import { Resource } from './resource';
import { Injectable, EventEmitter } from '@angular/core';
import { Hub } from './hub';
import { Config } from '@config';
import { CookieService } from '@tools';
import { GeneratedProxy } from './hub-proxies';
import { ContentLoader } from '@winforms';
import { MessageType, MessagesService } from '@ui-messages';

// export class GeneratedProxy<T extends GeneratedProxy<T, U>, U extends ResourceModel> {
//     hubName: string;
//     model: U;
//     hub: Hub<T>
// }

@Injectable()
export class ResourceService {
    private hubs: Record<string, Hub<unknown>> = {}
    private resources: Record<string, Resource<any, any>> = {};

    constructor(
        private config: Config,
        private cookieService: CookieService,
        private contentLoaderService: ContentLoader,
        private messageService: MessagesService
    ) {}

    private getHub<T extends GeneratedProxy<T, U>, U>(
        proxy: T,
        updatePredicate?: (prevModel, newModel) => boolean) {
        const hubName = proxy.hubName;

        let hub;
        hub = new Hub<T>(hubName, this.config, this.cookieService, updatePredicate);
        this.hubs[hubName] = hub;
        proxy.hub = hub;

        return hub;
    }

    public resource<T extends GeneratedProxy<T, U>, U>(
        proxyType: new() => T,
        topic: string,
        mapping?: (value) => any,
        updatePredicate?: (prevModel, newModel) => boolean): Promise<Resource<T, U>> {
        const proxy = new proxyType();
        const hubName = proxy.hubName;
        const resourceName = this.getResourceName(hubName, topic);

        if(this.resources[resourceName]) {
            return new Promise(async(resolve) => {
                await this.resources[resourceName].reconnect();
                resolve(this.resources[resourceName]);
            });
        }

        return new Promise(async(resolve, reject) => {
            try {
                await this.contentLoaderService.loadMvcScripts();
                const hub = this.getHub(proxy, updatePredicate);
                hub.onConnect.subscribe((current) => {
                    this.onReconnect.emit(true);
                });

                const resource = new Resource<T, U>(proxy, hub, topic, mapping);
                this.resources[resourceName] = resource;
                await hub.subscribe(topic);
                resource.commandResult$.subscribe((value) => {
                    console.info('Commad Result: [ResourceService.resource]', value)
                });
                return resolve(resource);
            }catch(e) {
                reject(e);
            }
        });
    }

    public onReconnect: EventEmitter<true> = new EventEmitter();

    private getResourceName(hubName: string, topic: string) {
        return hubName + '_' + topic;
    }
}
